<template>
  <div id="customer-history" class="position-relative">
    
    <!-- <div class="mt-6 flex items-center justify-between px-6">
      <h2 class="m-auto">HISTORY</h2>
    </div>
    <vs-divider class="mt-6 pt-3"></vs-divider> -->

    <VuePerfectScrollbar class="scroll-area--data-list-add-new sidebar-content">
      <vs-table
      ref="table"
      :max-items="itemsPerPage"
      :data="customerHistory"
      class="customer-history-table"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-end mt-4">
        <!-- <div class="justify-center my-3"> -->
          <!-- <vs-button type="border" color="danger" class="text-danger">Close</vs-button> -->
          <!-- <vs-button type="border" color="primary" class="text-primary">Show more</vs-button> -->
        <!-- </div> -->
        <vs-dropdown vs-trigger-click class="cursor-pointer item-per-page-dropdown" v-if="customerHistoryData._meta.totalCount > 0">
            <div
            class="px-4 py-3 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ customerHistoryData._meta.totalCount - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : customerHistoryData._meta.totalCount }} of {{ customerHistoryData._meta.totalCount }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
              <vs-dropdown-item v-for="(item, i) in options" :key="i" @click="changeItemsPerPage(currentPage = 1, itemsPerPage=item)" v-model="itemsPerPage">
                  <span class="w-full flex justify-between" :class="{'text-primary': itemsPerPage == item}">
                      {{item}}
                      <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="itemsPerPage == item"/>
                  </span>
              </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <template slot="thead">
        <vs-th class="center-title text-center">#</vs-th>
        <vs-th class="center-title text-center">Checked In At</vs-th>
        <vs-th class="center-title text-center">Checked Out At</vs-th>
        <vs-th class="center-title text-center">Point</vs-th>
        <vs-th class="center-title text-center">Check Out By</vs-th>
        <vs-th class="center-title text-center">
          Staffs
          <!-- <vx-tooltip text="Staffs chosen by customers at check-in" position="bottom">
            <feather-icon icon="HelpCircleIcon" svgClasses="w-5 stroke-current ml-2" />
          </vx-tooltip> -->
        </vs-th>
        <vs-th class="center-title text-center">Checkin Staffs</vs-th>
        <vs-th class="center-title text-center">
          Services
          <!-- <vx-tooltip text="Services chosen by customers at check-out" position="bottom">
            <feather-icon icon="HelpCircleIcon" svgClasses="w-5 stroke-current ml-2" />
          </vx-tooltip> -->
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="text-center">{{indextr + 1}}</vs-td>
            <vs-td>
              <p class="text-center">{{ changeFormat(tr.checked_in_at) }}</p>
              <p class="text-center">{{ getTime(tr.checked_in_at) }}</p>
            </vs-td>

            <vs-td>
              <p class="text-center">{{ changeFormat(tr.checked_out_at) }}</p>
              <p class="text-center">{{ getTime(tr.checked_out_at) }}</p>
            </vs-td>

            <vs-td class="text-center">
              {{ tr.point_added }}
            </vs-td>

            <vs-td class="text-center">
              {{ tr.checked_out_by ? tr.checked_out_by.name : 'N/A' }}
            </vs-td>

            <vs-td>
              <!-- <p class="user-name font-medium truncate">{{ tr.staffs }}</p> -->
              <div class="flex-center flex-wrap" v-if="tr.checkout_staffs && tr.checkout_staffs.length > 0">
                <span v-for="(staff, i) in tr.checkout_staffs" :key="i">
                  <i class="p-1 bg-success rounded text-white d-inline-block m-2 text-center" style="font-style: normal">{{staff.name}}</i>
                </span>
              </div>
              <div class="flex-center" v-else>N/A</div>
            </vs-td>
            
            <vs-td>
              <div class="flex-center flex-wrap" v-if="tr.staffs && tr.staffs.length > 0">
                <span v-for="(staff, i) in tr.staffs" :key="i">
                  <i class="p-1 bg-success rounded text-white d-inline-block m-2 text-center" style="font-style: normal">{{staff.name}}</i>
                </span>
              </div>
              <div class="flex-center" v-else>N/A</div>
            </vs-td>

            <vs-td>
              <!-- <p class="user-name font-medium truncate">{{ tr.services }}</p> -->
              <div class="flex-center flex-wrap" v-if="tr.services && tr.services.length > 0">
                <span v-for="(service, i) in tr.services" :key="i">
                  <i class="p-1 bg-warning rounded text-white d-inline-block m-2 text-center" style="font-style: normal">{{service.name}}</i>
                </span>
              </div>
              <div class="flex-center" v-else>N/A</div>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    </VuePerfectScrollbar>
    <!-- <div style="position: absolute; bottom: 0; left: 50%; transform: translateX(-50%); z-index: 900"> -->
      <div v-if="customerHistoryData._meta.pageCount" class="mt-6">
        <!-- <vs-pagination class="custom-pagination" :total="parseInt(customerHistoryData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination> -->
        <custom-pagination class="custom-pagination" :totalPages="parseInt(customerHistoryData._meta.pageCount)" :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
      </div>
    <!-- </div> -->
    <!-- <div class="vx-row justify-center my-3" slot="footer">
      <vs-button type="border" color="danger" class="text-danger">Close</vs-button>
      <vs-button type="border" color="primary" class="text-primary">Show more</vs-button>
    </div> -->
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import vSelect from "vue-select";
import moment from 'moment';
import {changeFormatHelper} from '../../helper/datetimeHelper';
export default {
  name: "vs-customer-history",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue"),
    "v-select": vSelect,
    VuePerfectScrollbar,
  },
  props: {
    activeCustomer: {
      type: Object,
      required: true
    } 
  },
  data() {
    let currentPage = 1;
    let itemsPerPage = 10;
    const obj = {
      id: this.activeCustomer.id,
      page: currentPage,
      'per-page': itemsPerPage
    }

    // let isLoaded = false;
    // let temp = {}
    this.$store.dispatch("customerList/GET_CUSTOMER_HISTORY", obj).then(() => {
      // this.isLoaded = true;
      // this.temp = JSON.parse(JSON.stringify(this.$store.getters["customerList/customerHistory"]));
    });
    return {
      // isLoaded,
      // temp,
      itemsPerPage,
      currentPage,
      isMounted: false,
      changeItemPerPage: false,
      options: [ 10,15,20],
      page_key: 0
    };
  },
  methods: {
    changeFormat(day) {
      if(day) {
        return changeFormatHelper(day);
      } else {
        return 'N/A';
      }
    },
    getTime(date) {
      if(date) {
        return moment(date).format('hh:mm A');
      } else {
        return '';
      }
    },
    changePage(currentPage) {
      // this.isCheckAll = false;
        const obj = {
            id: this.activeCustomer.id,
            page: currentPage,
            "per-page": this.itemsPerPage,
        }
        // this.openLoadingInDiv();
        this.$store.dispatch("customerList/GET_CUSTOMER_HISTORY", obj).then(() => {
          // this.closeLoading();
          this.currentPage = currentPage;
          this.page_key++;
        })
    },
    changeItemsPerPage(currentPage, itemsPerPage) {
      const obj = {
            id: this.activeCustomer.id,
            page: currentPage,
            "per-page": itemsPerPage,
        }
        // this.openLoadingInDiv();
        this.$store.dispatch("customerList/GET_CUSTOMER_HISTORY", obj).then(() => {
          // this.closeLoading();
          this.currentPage = currentPage;
          this.page_key++;
        })
    },
    closePopup() {
      this.$emit('ClosePopup');
      // this.temp = JSON.parse(JSON.stringify(this.$store.getters["customerList/customerInfo"]));
      // this.number0 = 0;
    },
  },
  computed: {
    customerHistory() {
      return this.$store.getters["customerList/customerHistory"];
    },
    customerHistoryData() {
      return this.$store.getters["customerList/customerHistoryData"];
    },
    // currentPage() {
    //   if (this.isMounted) {
    //     if (this.changeItemPerPage) {
    //       this.changeItemPerPage = false;
    //       this.$refs.table.currentx = 1;
    //     }
    //     return this.$refs.table.currentx;
    //   }
    //   return 0;
    // }, 
  },
  // mounted() {
  //   this.isMounted = true;
  // },
  // created() {
    
  // }
};
</script>